import * as constants from "../../../constants";

import {
  DeleteTaskCommentParams,
  GetCommentsParams,
  GetCommentsResult,
  GetTaskCommentParams,
  GetTaskCommentResult,
  GetTaskCommentsParams,
  GetTaskCommentsResult,
  UpdateTaskCommentParams,
} from "@/components/comment/actions/types";
import environments from "@/environments";

// コメント一覧取得
export const getComments = (params: GetCommentsParams, callback?: (res: GetCommentsResult) => void) => {
  const endpoint = `${environments.API_BASE_URI}/comments`;

  const query = new URLSearchParams();
  (params.category_id || []).forEach((id) => query.append("category_id[]", id.toString()));
  (params.primary_charge_id || []).forEach((id) => query.append("primary_charge_id[]", id.toString()));
  (params.area_id || []).forEach((id) => query.append("area_id[]", id.toString()));
  (params.device_id || []).forEach((id) => query.append("device_id[]", id.toString()));
  params.comment && query.set("comment", params.comment);
  params.insert_start_date && query.set("insert_start_date", params.insert_start_date);
  params.insert_end_date && query.set("insert_end_date", params.insert_end_date);
  query.set("start", params.start.toString());
  query.set("limit", params.limit.toString());
  query.set("order", "1"); // 1: コメント一覧用, 2: ホーム画面用

  return {
    type: constants.APP_CALL_API,
    endpoint: `${endpoint}?${query.toString()}`,
    method: "GET",
    callbacks: {
      begin: () => {
        return {
          type: constants.COMMENT_BEGIN_FETCH,
          payload: params,
        };
      },
      success: (response) => {
        callback?.(response);

        return {
          type: constants.COMMENT_END_FETCH,
          payload: response,
        };
      },
      error: (response) => {
        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};

// 明細別コメント一覧取得
export const getTaskComments = (params: GetTaskCommentsParams, callback?: (res: GetTaskCommentsResult) => void) => {
  const endpoint = `${environments.API_BASE_URI}/task_comments`;

  const query = new URLSearchParams();
  query.set("task_id", params.task_id.toString());

  return {
    type: constants.APP_CALL_API,
    endpoint: `${endpoint}?${query.toString()}`,
    method: "GET",
    callbacks: {
      begin: () => {
        return {
          type: constants.COMMENT_BEGIN_FETCH_TASK_COMMENTS,
          payload: params,
        };
      },
      success: (response) => {
        callback?.(response);

        return {
          type: constants.COMMENT_END_FETCH_TASK_COMMENTS,
          payload: response,
        };
      },
      error: (response) => {
        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};

// 明細別コメント1件取得
export const getTaskComment = (params: GetTaskCommentParams, callback?: (res: GetTaskCommentResult) => void) => {
  const endpoint = `${environments.API_BASE_URI}/task_comments/${params.task_comment_id}`;

  return {
    type: constants.APP_CALL_API,
    endpoint,
    method: "GET",
    callbacks: {
      begin: () => {
        return {
          type: constants.COMMENT_BEGIN_FETCH_TASK_COMMENT,
          payload: params,
        };
      },
      success: (response) => {
        callback?.(response);

        return {
          type: constants.COMMENT_END_FETCH_TASK_COMMENT,
          payload: response,
        };
      },
      error: (response) => {
        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};

// 明細コメント更新
export const updateTaskComment = (params: UpdateTaskCommentParams, callback?: (res) => void) => {
  const endpoint = `${environments.API_BASE_URI}/task_comments/${params.task_comment_id}/update`;

  return {
    type: constants.APP_CALL_API,
    endpoint,
    method: "POST",
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    body: JSON.stringify(params),
    callbacks: {
      begin: () => {
        return {
          type: constants.COMMENT_BEGIN_UPDATE_TASK_COMMENT,
        };
      },
      success: (response) => {
        callback?.(response);

        return {
          type: constants.COMMENT_END_UPDATE_TASK_COMMENT,
          payload: response,
        };
      },
      error: (response) => {
        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};

// 明細コメント削除
export const deleteTaskComment = (params: DeleteTaskCommentParams, callback?: () => void) => {
  const endpoint = `${environments.API_BASE_URI}/task_comments/${params.task_comment_id}/delete`;

  return {
    type: constants.APP_CALL_API,
    endpoint,
    method: "POST",
    body: JSON.stringify({ timestamp: params.timestamp }),
    headers: {
      "Content-Type": "application/json; charset=utf-8",
    },
    callbacks: {
      begin: () => {
        return {
          type: constants.COMMENT_BEGIN_DELETE_TASK_COMMENT,
        };
      },
      success: (response) => {
        callback?.();

        return {
          type: constants.COMMENT_END_DELETE_TASK_COMMENT,
          payload: response,
        };
      },
      error: (response) => {
        return {
          type: constants.APP_SHOW_ERROR,
          payload: response,
          error: true,
        };
      },
    },
  };
};

export const changeComment = (comment) => ({
  type: constants.COMMENT_CHANGE_COMMENT,
  payload: comment,
});
